import { useFlaggingCallback } from '@databases/banners';
import { useActionWithDependencies } from '@databases/redux';
import { useScope } from '@databases/scope';
import { getEntryCover } from '@databases/utils/coverImage';
import useView from '@databases/views/useView';
import React, { FunctionComponent } from 'react';

import CoverImage, { CoverImageProps } from '../CoverImage';
import { getSelectDatabaseDraft } from '../database-value/utils';

interface EntryCoverImageProps extends Omit<CoverImageProps, 'image'> {
  contentId: string;
  entryId: string;
}

/**
 * Renders the cover image of a database entry. If the database doesn't have a cover field defined, nothing is rendered.
 */
const EntryCoverImage: FunctionComponent<EntryCoverImageProps> = ({
  contentId,
  entryId,
  ...props
}) => {
  const scope = useScope();
  const {
    view: { settings: viewSettings },
  } = useView();
  const {
    result: { coverImage, fallback },
  } = useActionWithDependencies(
    useFlaggingCallback(
      (helpers) => {
        return getEntryCover(
          { contentId, entryId, viewSettings },
          {
            ...helpers,
            selectDatabase: getSelectDatabaseDraft(scope, true),
          }
        );
      },
      [contentId, entryId, scope, viewSettings]
    )
  );

  return (
    <CoverImage
      contentId={contentId}
      width="100%"
      {...props}
      image={coverImage}
      fallback={fallback?.src}
    />
  );
};

export default EntryCoverImage;
